import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Falha ao iniciar sessão',
  checkingSession: 'A verificar a tua sessão…',
  redirectingToSignIn: 'A redirecionar para o início de sessão…',
  signingIn: 'A iniciar sessão…',
  backToDashboard: 'Voltar ao painel',
};
